(() => {
  if (customElements.get('qr-pack-mobile-buy')) return;
  class QRPackMobileBuy extends HTMLElement {
    connectedCallback() {
      this.abort = new AbortController();
      this.root = this.closest('[data-qrpack-mobile]');
      this.purchase = this.root?.querySelector('.qrc-purchase');
      this.headingSlot = this.root?.querySelector('[data-qrpack-heading-slot]');
      this.button = this.querySelector('[data-qrpack-buy-button]');
      if (!this.root || !this.purchase || !this.headingSlot || !this.button) return;
      this.media = matchMedia('(max-width:749px)');
      this.price = this.querySelector('[data-qrpack-buy-price]');
      this.note = this.querySelector('[data-qrpack-buy-note]');
      this.defaultNote = this.note.textContent;
      this.anchor = document.createComment('');
      const heading = this.purchase.querySelector('h1');
      this.heading = heading?.closest('.group-block-content')?.parentElement;
      if (!this.heading?.classList.contains('group-block')) return;
      this.heading.before(this.anchor);
      const signal = this.abort.signal;
      this.rewards = document.createElement('button');
      this.rewards.type = 'button';
      this.rewards.className = 'qrpack-mobile-rewards';
      this.rewards.dataset.qrpackRewardsToggle = '';
      this.rewards.hidden = true;
      this.button.before(this.rewards);
      this.rewards.addEventListener('click', () => document.dispatchEvent(new CustomEvent('qr-rewards:expand')), { signal });
      this.schedule = () => {
        if (this.pending) return;
        this.pending = requestAnimationFrame(() => { this.pending = 0; this.update(); });
      };
      this.media.addEventListener('change', this.schedule, {signal});
      window.addEventListener('resize', this.schedule, {signal});
      window.visualViewport?.addEventListener('resize', this.schedule, {signal});
      document.addEventListener('scroll', this.schedule, {signal, capture:true, passive:true});
      document.addEventListener('focusin', this.schedule, {signal});
      document.addEventListener('focusout', this.schedule, {signal});
      document.addEventListener('qr-rewards:visibility', () => this.update(), {signal});
      this.root.addEventListener('change', this.schedule, {signal});
      this.root.addEventListener('input', this.schedule, {signal});
      this.root.addEventListener('submit', this.schedule, {signal});
      this.observer = new MutationObserver(records => {
        if (records.some(r => !this.contains(r.target))) this.schedule();
      });
      this.observer.observe(document.body, {subtree:true,childList:true,characterData:true,attributes:true,attributeFilter:['open','hidden','disabled','aria-disabled','aria-expanded','aria-hidden','data-zipchat-visible','class','style','value']});
      this.update();
    }
    visible(element) {
      if (!element || !element.getClientRects().length) return false;
      const style = getComputedStyle(element);
      if (style.display === 'none' || style.visibility === 'hidden') return false;
      const rect = element.getBoundingClientRect();
      return rect.width > 0 && rect.height > 0 && rect.bottom > 0 && rect.top < innerHeight;
    }
    update() {
      const mobile = this.media.matches;
      if (mobile && this.heading.parentElement !== this.headingSlot) {
        this.headingSlot.append(this.heading);
        this.root.dataset.qrpackEnhanced = 'true';
      } else if (!mobile && this.heading.parentElement === this.headingSlot) {
        this.anchor.after(this.heading);
        delete this.root.dataset.qrpackEnhanced;
      }
      const form = this.purchase.querySelector('form[action*="/cart/add"]');
      const native = form?.querySelector('button[type="submit"][name="add"]');
      const id = form?.querySelector('[name="id"]');
      if (form && this.button.form !== form) this.button.setAttribute('form',form.getAttribute('id'));
      const disabled = !native || native.disabled || native.getAttribute('aria-disabled') === 'true' || !id?.value || id.disabled;
      this.button.disabled = disabled;
      const label = disabled ? this.dataset.unavailableLabel : this.dataset.getLabel;
      if (this.button.textContent !== label) this.button.textContent = label;
      const nativePrice = this.heading.querySelector('product-price .price')?.textContent.trim();
      if (nativePrice && this.price.textContent !== nativePrice) this.price.textContent = nativePrice;
      const quantity = form?.querySelector('[name="quantity"]')?.value || '1';
      const note = quantity === '1' ? this.defaultNote : this.dataset.quantityLabel.replace('__COUNT__',quantity);
      if (this.note.textContent !== note) this.note.textContent = note;
      const preview = document.getElementById('PBarNextFrame');
      let previewOffset = 0;
      if (mobile && this.visible(preview)) {
        const parentRect = preview.parentElement?.getBoundingClientRect();
        previewOffset = parentRect && parentRect.height > 20 && parentRect.height < 150 ? parentRect.height : 64;
      }
      const offset = `${previewOffset}px`;
      if (document.documentElement.style.getPropertyValue('--qrpack-preview-offset') !== offset) document.documentElement.style.setProperty('--qrpack-preview-offset',offset);
      const active = document.activeElement;
      const editing = active?.matches('input:not([type="hidden"]):not([type="button"]):not([type="submit"]),textarea,select,[contenteditable="true"]');
      const viewport = window.visualViewport;
      const keyboard = viewport && viewport.scale <= 1.05 && innerHeight - viewport.height - viewport.offsetTop > 150;
      const dialog = [...document.querySelectorAll('dialog[open],[role="dialog"][aria-modal="true"],[role="alertdialog"]')].some(e=>this.visible(e));
      const cookie = this.visible(document.getElementById('shopify-pc__banner'));
      const chat = document.getElementById('zipchat-iframe')?.dataset.zipchatVisible === 'true';
      const footer = document.querySelector('footer');
      const atFooter = this.visible(footer) && !this.contains(active);
      const rewardsExpanded = document.documentElement.hasAttribute('data-qr-rewards-expanded');
      this.hidden = !mobile || !!editing || !!keyboard || dialog || cookie || chat || atFooter || rewardsExpanded;
      this.inert = this.hidden;
      const rewardsActive = document.documentElement.hasAttribute('data-qr-rewards-active');
      const rewardsCollapsed = document.documentElement.hasAttribute('data-qr-rewards-collapsed');
      this.rewards.hidden = !rewardsActive || !rewardsCollapsed;
      this.dataset.rewardsEntry = String(!this.rewards.hidden);
      const rewardsHost = document.querySelector('qr-quiz-rewards[data-context="sticky"]');
      const reopen = rewardsHost?.querySelector('[data-qr-rewards-expand]');
      const panel = rewardsHost?.querySelector('.qr-rewards__card');
      this.rewards.textContent = reopen?.textContent || '';
      this.rewards.setAttribute('aria-label', reopen?.getAttribute('aria-label') || '');
      this.rewards.setAttribute('aria-expanded', 'false');
      if (panel) this.rewards.setAttribute('aria-controls', panel.id);
      const visible = !this.hidden && this.getClientRects().length > 0;
      const height = visible ? Math.ceil(this.getBoundingClientRect().height + previewOffset) : 0;
      const reserved = `${height}px`;
      if (document.documentElement.style.getPropertyValue('--qr-mobile-purchase-reserved-space') !== reserved) document.documentElement.style.setProperty('--qr-mobile-purchase-reserved-space', reserved);
      const state = [visible, Boolean(editing), Boolean(keyboard), dialog, cookie, chat].join(':');
      if (this.reportedVisibility !== state) {
        this.reportedVisibility = state;
        document.dispatchEvent(new CustomEvent('qr-mobile-purchase:visibility', { detail: { visible } }));
      }
      const error = form?.querySelector('.product-form-text__error:not(.hidden)');
      if (error && error.textContent.trim() && error.textContent !== this.lastError) {
        this.lastError = error.textContent;
        error.tabIndex = -1;
        error.scrollIntoView({block:'center',behavior:'instant'});
        error.focus({preventScroll:true});
      } else if (!error) this.lastError = '';
    }
    disconnectedCallback() {
      this.abort?.abort();
      this.observer?.disconnect();
      cancelAnimationFrame(this.pending);
      if (this.anchor?.isConnected && this.heading?.parentElement === this.headingSlot) this.anchor.after(this.heading);
      this.anchor?.remove();
      this.root?.removeAttribute('data-qrpack-enhanced');
      document.documentElement.style.removeProperty('--qrpack-preview-offset');
      document.documentElement.style.removeProperty('--qr-mobile-purchase-reserved-space');
      this.rewards?.remove();
      document.dispatchEvent(new CustomEvent('qr-mobile-purchase:visibility', { detail: { visible: false } }));
    }
  }
  customElements.define('qr-pack-mobile-buy',QRPackMobileBuy);
})();
